<abp-page [title]="'Inventory::Assets' | abpLocalization">
  <abp-page-toolbar-container class="col">
    <div class="text-lg-end pt-2">
      <button
        *abpPermission="'Inventory.Assets.Create'"
        class="btn btn-primary btn-sm"
        type="button"
        (click)="create()"
      >
        <i class="fa fa-plus me-1" aria-hidden="true"></i>
        {{ 'Inventory::NewAsset' | abpLocalization }}
      </button>
    </div>
  </abp-page-toolbar-container>

  <abp-advanced-entity-filters localizationSourceName="Inventory" [list]="list">
    <abp-advanced-entity-filters-form>
      <form #filterForm (keyup.enter)="list.get()">
        <div class="row">
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="nameFilter">
                {{ 'Inventory::Name' | abpLocalization }}
              </label>

              <input
                id="nameFilter"
                class="form-control"
                [(ngModel)]="filters.name"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="descriptionFilter">
                {{ 'Inventory::Description' | abpLocalization }}
              </label>

              <input
                id="descriptionFilter"
                class="form-control"
                [(ngModel)]="filters.description"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="brandFilter">
                {{ 'Inventory::Brand' | abpLocalization }}
              </label>

              <input
                id="brandFilter"
                class="form-control"
                [(ngModel)]="filters.brand"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="invoiceDataFilter">
                {{ 'Inventory::InvoiceData' | abpLocalization }}
              </label>

              <input
                id="invoiceDataFilter"
                class="form-control"
                [(ngModel)]="filters.invoiceData"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="minPurshaseDate">
                  {{ 'Inventory::MinPurshaseDate' | abpLocalization }}
              </label>

              <div class="input-group" validationTarget>
                <input
                  id="minPurshaseDate"
                  class="form-control"
                  #minPurshaseDateInput
                  #minPurshaseDateDatepicker="ngbDatepicker"
                  name="minPurshaseDate"
                  ngbDatepicker
                  container="body"
                  readonly
                  (click)="minPurshaseDateDatepicker.toggle()"
                  (keyup.space)="minPurshaseDateDatepicker.toggle()"
                  [(ngModel)]="filters.purshaseDateMin"
                  [ngModelOptions]="{ standalone: true }"
                />
                <div *ngIf="minPurshaseDateInput.value" class="input-group-append">
                  <button
                    class="btn btn-link px-2"
                    type="button"
                    [title]="'AbpUi::Clear' | abpLocalization"
                    (click)="minPurshaseDateDatepicker.writeValue(null); minPurshaseDateDatepicker.manualDateChange(null, true)"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="maxPurshaseDate">
                {{ 'Inventory::MaxPurshaseDate' | abpLocalization }}
              </label>

              <div class="input-group" validationTarget>
                <input
                  id="maxPurshaseDate"
                  class="form-control"
                  #maxPurshaseDateInput
                  #maxPurshaseDateDatepicker="ngbDatepicker"
                  name="maxPurshaseDate"
                  ngbDatepicker
                  readonly
                  (click)="maxPurshaseDateDatepicker.toggle()"
                  (keyup.space)="maxPurshaseDateDatepicker.toggle()"
                  [(ngModel)]="filters.purshaseDateMax"
                  [ngModelOptions]="{ standalone: true }"
                />
                <div *ngIf="maxPurshaseDateInput.value" class="input-group-append">
                  <button
                    class="btn btn-link px-2"
                    type="button"
                    [title]="'AbpUi::Clear' | abpLocalization"
                    (click)="maxPurshaseDateDatepicker.writeValue(null); maxPurshaseDateDatepicker.manualDateChange(null, true)"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="minGarrantyExpirationDate">
                  {{ 'Inventory::MinGarrantyExpirationDate' | abpLocalization }}
              </label>

              <div class="input-group" validationTarget>
                <input
                  id="minGarrantyExpirationDate"
                  class="form-control"
                  #minGarrantyExpirationDateInput
                  #minGarrantyExpirationDateDatepicker="ngbDatepicker"
                  name="minGarrantyExpirationDate"
                  ngbDatepicker
                  container="body"
                  readonly
                  (click)="minGarrantyExpirationDateDatepicker.toggle()"
                  (keyup.space)="minGarrantyExpirationDateDatepicker.toggle()"
                  [(ngModel)]="filters.garrantyExpirationDateMin"
                  [ngModelOptions]="{ standalone: true }"
                />
                <div *ngIf="minGarrantyExpirationDateInput.value" class="input-group-append">
                  <button
                    class="btn btn-link px-2"
                    type="button"
                    [title]="'AbpUi::Clear' | abpLocalization"
                    (click)="minGarrantyExpirationDateDatepicker.writeValue(null); minGarrantyExpirationDateDatepicker.manualDateChange(null, true)"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="maxGarrantyExpirationDate">
                {{ 'Inventory::MaxGarrantyExpirationDate' | abpLocalization }}
              </label>

              <div class="input-group" validationTarget>
                <input
                  id="maxGarrantyExpirationDate"
                  class="form-control"
                  #maxGarrantyExpirationDateInput
                  #maxGarrantyExpirationDateDatepicker="ngbDatepicker"
                  name="maxGarrantyExpirationDate"
                  ngbDatepicker
                  readonly
                  (click)="maxGarrantyExpirationDateDatepicker.toggle()"
                  (keyup.space)="maxGarrantyExpirationDateDatepicker.toggle()"
                  [(ngModel)]="filters.garrantyExpirationDateMax"
                  [ngModelOptions]="{ standalone: true }"
                />
                <div *ngIf="maxGarrantyExpirationDateInput.value" class="input-group-append">
                  <button
                    class="btn btn-link px-2"
                    type="button"
                    [title]="'AbpUi::Clear' | abpLocalization"
                    (click)="maxGarrantyExpirationDateDatepicker.writeValue(null); maxGarrantyExpirationDateDatepicker.manualDateChange(null, true)"
                  >
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="serialNumberFilter">
                {{ 'Inventory::SerialNumber' | abpLocalization }}
              </label>

              <input
                id="serialNumberFilter"
                class="form-control"
                [(ngModel)]="filters.serialNumber"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="internalCodeFilter">
                {{ 'Inventory::InternalCode' | abpLocalization }}
              </label>

              <input
                id="internalCodeFilter"
                class="form-control"
                [(ngModel)]="filters.internalCode"
                [ngModelOptions]="{ standalone: true }"
              />
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="assetTypeIdFilter">
                {{ 'Inventory::AssetType' | abpLocalization }}
              </label>
              <abp-lookup-input
                cid="assetTypeIdFilter"
                displayNameProp="name"
                lookupNameProp="displayName"
                [getFn]="service.getAssetTypeLookup"
                [(ngModel)]="filters.assetTypeId"
                [ngModelOptions]="{ standalone: true }"
              ></abp-lookup-input>
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="assetStatusIdFilter">
                {{ 'Inventory::AssetStatus' | abpLocalization }}
              </label>
              <abp-lookup-input
                cid="assetStatusIdFilter"
                displayNameProp="name"
                lookupNameProp="displayName"
                [getFn]="service.getAssetStatusLookup"
                [(ngModel)]="filters.assetStatusId"
                [ngModelOptions]="{ standalone: true }"
              ></abp-lookup-input>
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="assetModelIdFilter">
                {{ 'Inventory::AssetModel' | abpLocalization }}
              </label>
              <abp-lookup-input
                cid="assetModelIdFilter"
                displayNameProp="name"
                lookupNameProp="displayName"
                [getFn]="service.getAssetModelLookup"
                [(ngModel)]="filters.assetModelId"
                [ngModelOptions]="{ standalone: true }"
              ></abp-lookup-input>
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="providerIdFilter">
                {{ 'Inventory::Provider' | abpLocalization }}
              </label>
              <abp-lookup-input
                cid="providerIdFilter"
                displayNameProp="name"
                lookupNameProp="displayName"
                [getFn]="service.getProviderLookup"
                [(ngModel)]="filters.providerId"
                [ngModelOptions]="{ standalone: true }"
              ></abp-lookup-input>
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="inventoryLocationIdFilter">
                {{ 'Inventory::InventoryLocation' | abpLocalization }}
              </label>
              <abp-lookup-input
                cid="inventoryLocationIdFilter"
                displayNameProp="name"
                lookupNameProp="displayName"
                [getFn]="service.getInventoryLocationLookup"
                [(ngModel)]="filters.inventoryLocationId"
                [ngModelOptions]="{ standalone: true }"
              ></abp-lookup-input>
            </div>
          </div>
          <div class="col-12 col-sm-auto">
            <div class="mb-3">
              <label class="form-label" for="legalDocumentIdFilter">
                {{ 'Inventory::LegalDocument' | abpLocalization }}
              </label>
              <abp-lookup-input
                cid="legalDocumentIdFilter"
                displayNameProp="description"
                lookupNameProp="displayName"
                [getFn]="service.getLegalDocumentLookup"
                [(ngModel)]="filters.legalDocumentId"
                [ngModelOptions]="{ standalone: true }"
              ></abp-lookup-input>
            </div>
          </div>

          <div class="col-12 col-sm-auto align-self-end mb-3">
            <div class="row">
              <div class="col-6 col-sm-auto d-grid">
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  (click)="clearFilters()"
                >
                  <span>{{ 'AbpUi::Clear' | abpLocalization }}</span>
                </button>
              </div>
              <div class="col-6 col-sm-auto d-grid">
                <button type="button" class="btn btn-primary" (click)="list.get()">
                  <span>{{ 'AbpUi::Refresh' | abpLocalization }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </abp-advanced-entity-filters-form>
  </abp-advanced-entity-filters>

  <div class="card">
    <div class="card-body">
      <ngx-datatable [rows]="data.items" [count]="data.totalCount" [list]="list" default>
        <ngx-datatable-column
          [name]="'AbpUi::Actions' | abpLocalization"
          [maxWidth]="150"
          [width]="150"
          [sortable]="false"
        >
          <ng-template let-row="row" let-i="rowIndex" ngx-datatable-cell-template>
            <div ngbDropdown container="body" class="d-inline-block">
              <button
                class="btn btn-primary btn-sm dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                ngbDropdownToggle
              >
                <i class="fa fa-cog me-1" aria-hidden="true"></i>
                {{ 'AbpUi::Actions' | abpLocalization }}
              </button>

              <div ngbDropdownMenu>
                <button
                  ngbDropdownItem
                  *abpPermission="'Inventory.Assets.Edit'"
                  (click)="update(row)"
                >
                  {{ 'AbpUi::Edit' | abpLocalization }}
                </button>

                <button
                  ngbDropdownItem
                  *abpPermission="'Inventory.Assets.Delete'"
                  (click)="delete(row)"
                >
                  {{ 'AbpUi::Delete' | abpLocalization }}
                </button>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::Name' | abpLocalization }}" prop="asset.name">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.asset.name }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::Description' | abpLocalization }}" prop="asset.description">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.asset.description }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::Brand' | abpLocalization }}" prop="asset.brand">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.asset.brand }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::InvoiceData' | abpLocalization }}" prop="asset.invoiceData">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.asset.invoiceData }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::PurshaseDate' | abpLocalization }}" prop="asset.purshaseDate">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.asset.purshaseDate | date }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::GarrantyExpirationDate' | abpLocalization }}" prop="asset.garrantyExpirationDate">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.asset.garrantyExpirationDate | date }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::SerialNumber' | abpLocalization }}" prop="asset.serialNumber">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.asset.serialNumber }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::InternalCode' | abpLocalization }}" prop="asset.internalCode">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.asset.internalCode }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::AssetType' | abpLocalization }}" prop="assetType.name">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.assetType?.name }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::AssetStatus' | abpLocalization }}" prop="assetStatus.name">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.assetStatus?.name }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::AssetModel' | abpLocalization }}" prop="assetModel.name">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.assetModel?.name }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::Provider' | abpLocalization }}" prop="provider.name">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.provider?.name }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::InventoryLocation' | abpLocalization }}" prop="inventoryLocation.name">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.inventoryLocation?.name }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="{{ 'Inventory::LegalDocument' | abpLocalization }}" prop="legalDocument.description">
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.legalDocument?.description }}
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
  </div>
</abp-page>

<abp-modal [busy]="isModalBusy" [(visible)]="isModalOpen">
  <ng-template #abpHeader>
    <h3>
      {{ (selected ? 'AbpUi::Edit' : 'Inventory::NewAsset') | abpLocalization }}
    </h3>
  </ng-template>

  <ng-template #abpBody>
    <form [formGroup]="form" (ngSubmit)="submitForm()" validateOnSubmit>
      <div class="mt-2 fade-in-top">
        <div class="mb-3">
          <label class="form-label" for="asset-name">
            {{ 'Inventory::Name' | abpLocalization }} *
          </label>

          <input
            id="asset-name"
            formControlName="name"
            class="form-control"
            autofocus
          />
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-description">
            {{ 'Inventory::Description' | abpLocalization }} 
          </label>

          <input
            id="asset-description"
            formControlName="description"
            class="form-control"
          />
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-brand">
            {{ 'Inventory::Brand' | abpLocalization }} 
          </label>

          <input
            id="asset-brand"
            formControlName="brand"
            class="form-control"
          />
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-invoice-data">
            {{ 'Inventory::InvoiceData' | abpLocalization }} 
          </label>

          <input
            id="asset-invoice-data"
            formControlName="invoiceData"
            class="form-control"
          />
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-purshase-date">
            {{ 'Inventory::PurshaseDate' | abpLocalization }} 
          </label>

          <div class="input-group" validationTarget>
            <input
              readonly
              id="asset-purshase-date"
              formControlName="purshaseDate"
              class="form-control"
              ngbDatepicker
              #purshaseDateInput
              #purshaseDateDatepicker="ngbDatepicker"
              (click)="purshaseDateDatepicker.open()"
              (keyup.space)="purshaseDateDatepicker.open()"
            />
            <div *ngIf="purshaseDateInput.value" class="input-group-append">
              <button
                class="btn btn-link px-2"
                type="button"
                [title]="'AbpUi::Clear' | abpLocalization"
                (click)="purshaseDateDatepicker.writeValue(null); purshaseDateDatepicker.manualDateChange(null, true)"
              >
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-garranty-expiration-date">
            {{ 'Inventory::GarrantyExpirationDate' | abpLocalization }} 
          </label>

          <div class="input-group" validationTarget>
            <input
              readonly
              id="asset-garranty-expiration-date"
              formControlName="garrantyExpirationDate"
              class="form-control"
              ngbDatepicker
              #garrantyExpirationDateInput
              #garrantyExpirationDateDatepicker="ngbDatepicker"
              (click)="garrantyExpirationDateDatepicker.open()"
              (keyup.space)="garrantyExpirationDateDatepicker.open()"
            />
            <div *ngIf="garrantyExpirationDateInput.value" class="input-group-append">
              <button
                class="btn btn-link px-2"
                type="button"
                [title]="'AbpUi::Clear' | abpLocalization"
                (click)="garrantyExpirationDateDatepicker.writeValue(null); garrantyExpirationDateDatepicker.manualDateChange(null, true)"
              >
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-serial-number">
            {{ 'Inventory::SerialNumber' | abpLocalization }} 
          </label>

          <input
            id="asset-serial-number"
            formControlName="serialNumber"
            class="form-control"
          />
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-internal-code">
            {{ 'Inventory::InternalCode' | abpLocalization }} 
          </label>

          <input
            id="asset-internal-code"
            formControlName="internalCode"
            class="form-control"
          />
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-asset-type-id">
            {{ 'Inventory::AssetType' | abpLocalization }} *
          </label>
          <abp-lookup-input
            cid="asset-asset-type-id"
            formControlName="assetTypeId"
            displayNameProp="name"
            lookupNameProp="displayName"
            [getFn]="service.getAssetTypeLookup"
            [editingData]="selected?.assetType"
          ></abp-lookup-input>
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-asset-status-id">
            {{ 'Inventory::AssetStatus' | abpLocalization }} *
          </label>
          <abp-lookup-input
            cid="asset-asset-status-id"
            formControlName="assetStatusId"
            displayNameProp="name"
            lookupNameProp="displayName"
            [getFn]="service.getAssetStatusLookup"
            [editingData]="selected?.assetStatus"
          ></abp-lookup-input>
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-asset-model-id">
            {{ 'Inventory::AssetModel' | abpLocalization }} *
          </label>
          <abp-lookup-input
            cid="asset-asset-model-id"
            formControlName="assetModelId"
            displayNameProp="name"
            lookupNameProp="displayName"
            [getFn]="service.getAssetModelLookup"
            [editingData]="selected?.assetModel"
          ></abp-lookup-input>
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-provider-id">
            {{ 'Inventory::Provider' | abpLocalization }} 
          </label>
          <abp-lookup-input
            cid="asset-provider-id"
            formControlName="providerId"
            displayNameProp="name"
            lookupNameProp="displayName"
            [getFn]="service.getProviderLookup"
            [editingData]="selected?.provider"
          ></abp-lookup-input>
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-inventory-location-id">
            {{ 'Inventory::InventoryLocation' | abpLocalization }} 
          </label>
          <abp-lookup-input
            cid="asset-inventory-location-id"
            formControlName="inventoryLocationId"
            displayNameProp="name"
            lookupNameProp="displayName"
            [getFn]="service.getInventoryLocationLookup"
            [editingData]="selected?.inventoryLocation"
          ></abp-lookup-input>
        </div>
        <div class="mb-3">
          <label class="form-label" for="asset-legal-document-id">
            {{ 'Inventory::LegalDocument' | abpLocalization }} 
          </label>
          <abp-lookup-input
            cid="asset-legal-document-id"
            formControlName="legalDocumentId"
            displayNameProp="description"
            lookupNameProp="displayName"
            [getFn]="service.getLegalDocumentLookup"
            [editingData]="selected?.legalDocument"
          ></abp-lookup-input>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #abpFooter>
    <button type="button" class="btn btn-secondary" abpClose>
      {{ 'AbpUi::Cancel' | abpLocalization }}
    </button>

    <abp-button iconClass="fa fa-check" (click)="submitForm()" [disabled]="form?.invalid">
      {{ 'AbpUi::Save' | abpLocalization }}
    </abp-button>
  </ng-template>
</abp-modal>
